import { LoginScreen } from "@synergy/microfrontend_core";
import { Routes as AppRoutes, BrowserRouter, Route } from "react-router-dom";
import BrandLogo from "../../../assets/img/BrandLogo_white.svg";
import { Home } from "../../Pages/Home";
import { ProtectedRoute } from "./ProtectedRoutes";
import { PublicRoute } from "./PublicRoutes";
export function Routes() {
    return (
        <BrowserRouter>
            {/* <ScrollToTop /> */}
            <AppRoutes>
                {/* PUBLIC ROUTES */}
                <Route element={<PublicRoute />}>
                    <Route path="/" element={<LoginScreen logo={BrandLogo} />} />
                </Route>

                {/* PRIVATE ROUTES */}
                <Route element={<ProtectedRoute />}>
                    <Route path="/*" element={<Home />} />
                </Route>

                {/* NO MATCH ROUTES */}
                {/* <Route path="*" element={<NoMatch />} /> */}
            </AppRoutes>
        </BrowserRouter>
    );
}